import * as React from "react";
import {
  Box,

  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  useMediaQuery,
  useTheme,
  Typography,
  TextField,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import Questionnaire from "./questionnarie";
import { UserList } from "./userList";
import Notifications from "./notifications";
import { ApiCredential } from "./api-credential";
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  resetAll,
  setSelectedSellerID,
  patchApproveStatus,
  patchRejectStatus,
  patchOnholdStatus,
  patchCertifiedStatus,
  patchBuildingStatus,
  getSelectedSeller,
  setSelectedStatus,
  getRejectionStatuses
} from "../../redux/slices/sellerSlice";
import getStatusModal from "../buttons";
import EmailOutlinedIcon from '@mui/icons-material/Email';
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate, useParams } from "react-router-dom";
import SellerProfile from "../sellerProfile"
import { ReactComponent as Profile } from '../../assets/images/profile.svg'
import { ReactComponent as Users } from '../../assets/images/users.svg'
import { ReactComponent as Notification } from '../../assets/images/notification.svg'
import { ReactComponent as Api } from '../../assets/images/api.svg'
import { ReactComponent as Questions } from '../../assets/images/questions.svg'
import ModalFunction from "../sellerProfile/resendActivation";
import CustomDropdown from "../sellerProfile/CustomDropdown";
import CheckIcon from '@mui/icons-material/Check';
import ReplayIcon from '@mui/icons-material/Replay';
import { CustomBreadcrumbs } from "../sellerProfile/styles";
import {
  APPROVESELLER,
  BUILDING,
  CERTIFIED,
  PLACEONHOLD,
  REJECTSELLER,
} from "../../utils/constants";
import FieldError from "../sellerProfile/editForm/FieldError";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const TAB_INDICATOR_WIDTHS = ['129px', '149px', '179px', '197px', '239px'];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SellerData = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const msalUser = useSelector(
    state => state.seller.msal.user
  );
  const selectedSeller = useSelector(
    state => state.seller.selectedSeller,
    shallowEqual
  )
  const selectedStatus = useSelector(
    state => state.seller.selectedStatus
  )
  useEffect(() => {
    dispatch(getRejectionStatuses());
  }, [dispatch])

  const rejectionStatuses = useSelector(({ seller: { rejectionStatuses } }) => ({
      rejectionStatuses,
    }));
  
  useEffect(() => {
    msalUser && dispatch(getSelectedSeller({ id: params.id }));

  }, [msalUser, dispatch, params.id]);
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleConfirm = (status) => {
    switch (status) {
      case APPROVESELLER:
        return () => {
          dispatch(patchApproveStatus());
        };
      case REJECTSELLER:
        return (payload) => {
          dispatch(patchRejectStatus(payload));
        };
      case PLACEONHOLD:
        return (payload) => {
          dispatch(patchOnholdStatus(payload));
        };
      case CERTIFIED:
        return () => {
          dispatch(patchCertifiedStatus());
        };
      case BUILDING:
        return () => {
          dispatch(patchBuildingStatus());
        };

      default:
        return () => { };
    }
  };

  const getStatusButtons = () => {
    if (!selectedStatus) return;
    const status = selectedSeller.status_type;
    return getStatusModal({
      status,
      selectedStatus: selectedStatus,
      handlers: {
        handleConfirm: handleConfirm(selectedStatus),
        handleSelectedStatus: () =>
          dispatch(setSelectedStatus({ data: selectedStatus })),
      },
    });
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const [value, setValue] = React.useState(0);
  const [selectedTab, setSelectedTab] = React.useState(2);
  const [formEdit, setFormEdit] = React.useState(false);
  const [companyNameEdit, setCompanyNameEdit] = React.useState(selectedSeller?.company_name || "");

  // Update companyNameEdit when selectedSeller changes
  React.useEffect(() => {
    if (selectedSeller?.company_name) {
      setCompanyNameEdit(selectedSeller.company_name);
    }
  }, [selectedSeller?.company_name, formEdit]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTabsChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const handleTabMenuItemClick = (val) => {
    setValue(val);
  };

  const handleBack = () => {

    dispatch(setSelectedSellerID({ data: "" }));
    dispatch(resetAll());
    navigate("/");

  };

  return (
    <Box sx={{ width: '100%', mt: '120px' }}>
      <CustomBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: '20px' }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "1.125rem",
            cursor: "pointer",
          }}
          component="div"
          onClick={handleBack}
        >
          Seller List
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            cursor: "pointer",
            fontWeight: 700,
            lineHeight: "1.125rem",
            color: '#000000'
          }}
          component="div"
        >
          {selectedSeller?.company_name}
        </Typography>


      </CustomBreadcrumbs>
      <Box sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

      }}>

        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
          }}>

          {formEdit ? (
            <TextField
              value={companyNameEdit}
              variant="standard"
              fullWidth
              required={true}
              label={"Company name"}
               error={!companyNameEdit?.trim()}
              helperText={
                !companyNameEdit?.trim() ? (
                  <Box
                    component="span"
                    sx={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
                  >
                    <FieldError message="This field is required"/>
                    
                  </Box>
                ) : ""
              }
              InputLabelProps={{
                shrink: true, 
                sx: {
                  color: '#6D6D6F',
                  fontSize: '12px',
                  lineHeight: '16px',
                  letterSpacing: 0,
                }
              }}
              onChange={(e) => { setCompanyNameEdit(e.target.value) }}
              sx={{
                '& .MuiInput-input': {
                  color: '#000000',
                  fontSize: '28px !important',
                  lineHeight: '20px',
                  letterSpacing: 0,
                  fontWeight: 700,
                  py: '6px',
                },
                '& .MuiFormLabel-asterisk': { color: '#D32F2F' },
                '& .MuiInput-underline:before': {
                  borderBottomColor: '#C4C4C4',
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                  borderBottomColor: '#1460AA',
                },
                maxWidth:'902px'

              }}
            />
          ) : (
            <Typography variant="h2" sx={{ fontSize: '28px', fontWeight: 700, color: '#000000' }}>{selectedSeller?.company_name}</Typography>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {
              [
                "AE","APA"
              ].includes(selectedSeller?.status_type) ? (
                <Box
                  sx={{
                    backgroundColor: '#EFF0F2',
                    p: '8px 16px 8px 16px',
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    mb: '16px'
                  }}
                >
                  <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#6D6D6F' }}>
                    Pending activation
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <EmailOutlinedIcon sx={{ width: '16px', height: '16px', color: '#1460AA' }}></EmailOutlinedIcon>
                    <Typography
                      component={"a"}
                      href="#"
                      sx={{
                        color: '#1460AA',
                        fontWeight: 700,
                        fontSize: '14px',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        '&:hover': {
                          color: '#1460AA',
                        },
                        '&:focus-visible': {
                          outline: '2px solid #1460AA',
                          outlineOffset: '2px',
                        },
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleModalOpen();
                      }}
                    >
                      Resend Details
                    </Typography>
                  </Box>
                </Box>

              ) : null}
            <ModalFunction
              open={isModalOpen}
              onClose={handleModalClose}
              userName={""}
              sellerId={params.id}
            />
            {!["CE"].includes(
              selectedSeller?.status_type
            ) ? <CustomDropdown handleConfirm={handleConfirm(selectedStatus)}></CustomDropdown> :
              <Button
                endIcon={<CheckIcon></CheckIcon>}
                sx={{
                  mb: 1,
                  px: "16px",
                  py: "8px",
                  minWidth: "282px",
                  height: "40px",
                  borderRadius: "999px",
                  textTransform: "none",
                  justifyContent: "space-between",
                  bgcolor: "#DFF0DB",
                  color: "#20842F",
                  fontWeight: 500,
                  fontSize: '16px',
                  "&:hover": { bgcolor: "#DFF0DB" },
                }}
              >
                Certified
              </Button>
            }
            <Box
              sx={{
                mr: isMobile ? 0 : "5rem",
                display: "flex",
                flexDirection: "column",
                width: '100%',
                alignItems: 'center',
              }}
            >
              {getStatusButtons()}
            </Box>
            {
              selectedSeller?.status_type === 'RJ' && (
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  mb: '16px',
                }}>
                  <Box>
                    <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#6D6D6F', marginBottom: '4px' }}>
                      Reason
                    </Typography>
                    <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#000000' }}>
                      {selectedSeller?.rejection_reason ? (rejectionStatuses.rejectionStatuses?.find(o=>o.rejection_reason===selectedSeller?.rejection_reason)?.rejection_reason_en ?? '-') : '-'}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#6D6D6F', marginBottom: '4px' }}>
                      Comment
                    </Typography>
                    <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#000000' }}>
                      {selectedSeller?.rejection_reason_comments ? selectedSeller?.rejection_reason_comments : '-'}
                    </Typography>
                  </Box>

                </Box>
              )
            }
            {
              selectedSeller?.status_type === 'OH' && (
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  mb: '16px'
                }}>
                  <Box>
                    <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#6D6D6F', marginBottom: '4px' }}>
                      Comments
                    </Typography>
                    <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#000000' }}>
                      {selectedSeller?.reminder_comments || selectedSeller?.on_hold_comments || 'None'}
                    </Typography>
                  </Box>
                </Box>
              )
            }
          </Box>
        </Box>

        <Box
          sx={{
            width: '100%',
          }}
        >
          {isMobile ? (
            <Box sx={{ m: 2, mx: 2, width: "100%" }}>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="demo-simple-select-standard-label">
                  View
                </InputLabel>
                <Select
                  sx={{ width: "100%" }}
                  value={value}
                  onChange={(event) =>
                    handleTabMenuItemClick(event.target.value)
                  }
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                >
                  <MenuItem value={0}>User List</MenuItem>
                  <MenuItem value={1}>Notifications</MenuItem>
                  <MenuItem value={2}>API Credentials</MenuItem>
                  <MenuItem value={3}>API Specifications</MenuItem>
                </Select>
              </FormControl>
            </Box>
          ) : (
            <Tabs
              variant="fullWidth"
              sx={{
                borderBottom: '0.5px solid grey',

                minWidth: '90px',

                "& .MuiTabs-indicator": {
                  backgroundColor: '#1460AA',
                  height: '3px',
                  width: TAB_INDICATOR_WIDTHS[value] + ' !important',
                },
                "& .MuiTab-root": {
                  justifyContent: 'flex-start',
                  minWidth: '90px',
                  color: "#000000", // Use theme for default color
                  "&.Mui-selected": {
                    // Target selected tab
                    color: "#1460AA", // Set color to AC blue on selection
                  },
                },
              }}
              value={value}
              onChange={(handleTabsChange, handleChange)}
              // aria-label="secondary tabs example"
              bvalue={selectedTab}
            >
              <Tab
                icon={<Profile width={24} height={24}></Profile>}
                iconPosition="start"
                sx={{
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: "500",
                  textDecoration: "none",
                }}
                label="Profile"
                {...a11yProps(0)}
              />
              <Tab
                icon={<Users width={24} height={24}></Users>}
                iconPosition="start"
                sx={{
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: "500",
                  textDecoration: "none",
                  textAlign: 'left'
                }}
                label="User List"
                {...a11yProps(1)}
              />
              <Tab
                icon={<Notification width={24} height={24}></Notification>}
                iconPosition="start"
                sx={{
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
                label="Notifications"
                {...a11yProps(2)}
              />
              <Tab
                icon={<Api width={24} height={24}></Api>}
                iconPosition="start"
                sx={{
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
                label="API Credentials"
                {...a11yProps(3)}
              />
              <Tab
                icon={<Questions width={24} height={24}></Questions>}
                iconPosition="start"
                sx={{
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
                label="API Specifications"
                {...a11yProps(4)}
              />
            </Tabs>
          )}
        </Box>
        <Box sx={{ width: '100%' }}>
          <CustomTabPanel value={value} index={0}>
            <SellerProfile
              selectedSeller={selectedSeller}
              formEdit={formEdit}
              setFormEdit={setFormEdit}
              companyNameEdit={companyNameEdit}
              setCompanyNameEdit={setCompanyNameEdit}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <UserList></UserList>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            {value === 2 && <Notifications />}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <ApiCredential />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <Questionnaire />
          </CustomTabPanel>
        </Box>

      </Box>
    </Box>
  );
};
export default SellerData;